import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../data/i18n";

const NotFound = () => {
  const { lang } = useI18n();
  const isBg = lang === "bg";

  return (
    <div className="bg-[#0a0a0a] pt-40 pb-24 min-h-screen flex items-center justify-center px-6 text-center">
      <div>
        <p className="section-label">404</p>
        <h1 className="display text-5xl md:text-7xl text-[#f5f0e6] mt-3 mb-6">
          {isBg ? "Страницата не е намерена" : "Page not found"}
        </h1>
        <p className="text-[#cfc7b8] mb-10">
          {isBg ? "Адресът може да е променен или страницата вече да не съществува." : "The address may have changed or the page may no longer exist."}
        </p>
        <Link to="/" className="cb-btn cb-btn-gold inline-block">
          <span className="cb-btn-text cb-btn-text-1">{isBg ? "Към началната страница" : "Back to homepage"}</span>
          <span className="cb-btn-text cb-btn-text-2" aria-hidden="true">
            {isBg ? "Към началната страница" : "Back to homepage"}
          </span>
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
